export const onboardingFormMocks = {
      contactInformation: {
        organization: 'my organization',
        clientOrganization: 'client organization',
        contactName: 'josé',
        email: 'jose@gmail.pt',
        phone: '+19191919191919',
        name: 'jose'
      },
      instances: {
        instances: {
          instancesSetup: {
            servicePeriod: "12"
          },
          1: {
            urlType: 'purchaseDomain',
            dhisVersion: '228',
            instancePurpose: 'testing',
            hostingPlan: 't-3',
            servicePeriod: '12'
          },
          2: {
            urlType: 'purchaseDomain',
            dhisVersion: '228',
            instancePurpose: 'testing',
            hostingPlan: 't-3',
            servicePeriod: '12'
          }
        }
      },
      addOns: {
        integrationDriver: true,
        dhis2SupportPlan: true
      },
      billing: {
        name: 'sds',
        country: 'Uganda',
        email: 'dsdsd@sapo.pt',
        billingAddress: 'sdsdsds',
        city: 'sdsd',
        state: 'sd',
        postalCode: 's',
        poNumber: 'sds',
        billingFrequency: '6',
        billingCurrency: 'euro',
        phoneNumber: '+12345678909'
      }
    };
